'use client';

import { NextIntlClientProvider } from 'next-intl';
import type { AbstractIntlMessages } from 'next-intl';

interface IntlProviderProps {
  locale: string;
  messages: AbstractIntlMessages;
  children: React.ReactNode;
}

export function IntlProvider({ locale, messages, children }: IntlProviderProps) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone="Europe/Berlin"
      onError={(error) => {
        if (process.env.NODE_ENV === 'development') {
          console.warn('[next-intl]', error.message);
        }
      }}
      getMessageFallback={({ namespace, key }) => {
        const fullKey = namespace ? `${namespace}.${key}` : key;
        if (process.env.NODE_ENV === 'development') {
          return `[MISSING: ${fullKey}]`;
        }
        return key;
      }}
    >
      {children}
    </NextIntlClientProvider>
  );
}
